/*** IMPORTS FROM imports-loader ***/
(function() {

define(
[
	'jquery',
    'pip-model',
    'pip-common.validate',
    'pip-common.utils',
    'pip-common.overlay',
    'pip-common.quantity',
    'pip-events',
    'pip-analytics__messaging',
    'mustache',
    'pip-cart',
    'thd-videoPlayer'
],
function(
    $,
    pip,
    pipValidate,
    pipUtils,
    pipOverlay,
    pipQuantity,
    pipEvents,
    pipAnalyticsMessaging,
    Mustache,
    pipCart,
    videoPlayer
){

    var expressDeliveryOverlayInstance;

    var RESPONSE_CODES = {
        ERROR: {
            'NO_BODFS_STORES': 'Sorry, this item is not available for delivery in this ZIP code. <br />Enter a valid ZIP code or select another fulfillment method.',
            'NO_STORES': 'Sorry, this item is not available for delivery in this ZIP code. <br />Enter a valid ZIP code or select another fulfillment method.',
            'ITEM_NOT_ASSORTED': 'Sorry, this item is not available for delivery in this ZIP code. <br />Enter a valid ZIP code or select another fulfillment method.',
            'ALPHA_PROMPT_RESTRICTION': 'Sorry, this item must be purchased in store for this ZIP code.',
            'INVALID_ZIPCODE': 'Please enter a valid zip code.',
            'NO_INVENTORY': 'Sorry, this item is not in stock for delivery in this ZIP code. <br />Please select another fulfillment method.',
            'NOT_ENOUGH_INVENTORY': 'Sorry, not all items are in stock for delivery in this ZIP code. Please update your quantity or select another fulfillment method.',
            'INVALID_QUANTITY': 'Please enter a valid quantity.',
            'NOT_FOUND': 'Delivery scheduling is unavailable for this order.',
            'NOT_BODFS_ELG': 'Delivery scheduling is unavailable for this order.',
            'NO_BODFS_ITEMS': 'Delivery scheduling is unavailable for this order.',
            'ZIPCODE_SERVICE_DOWN': 'Delivery scheduling is unavailable.<br/>You may still add this item to your cart and complete your order.',
            'PRD_SRCH_ERR_503': 'Delivery scheduling is unavailable.<br/>You may still add this item to your cart and complete your order.',
            'GENERIC_ERROR': "<b>We're sorry.</b> We're currently unable to access scheduling information. Please try again shortly."
        }
    };

    var ExpressDeliveryOverlay = function ExpressDeliveryOverlay() {
        var _this = this;

        this.className = 'pip-overlay__express-delivery';

        this.model = {
            availability: {
                result: {
                    visible: false
                },
                form: {
                    visible: true
                },
                zipCode: null,
                quantity: null
            },
            cart: {
                visible: false,
                button: {
                    disabled: false
                }
            },
            messaging: {
                date: null,
                messageState: null,
                messageText: null
            },
            isErrorState: false
        };

        this.view = {
            templates: {
                expressDeliveryContent: $('#express-delivery-overlay').html(),
                expressDeliveryContentUpdated: $('#express-delivery-overlay_text-updated').html(),
                calculator: $('#express-delivery-overlay__calculator').html()
            },


            render: {
                errorTemplate: function renderErrorTemplate(errorCode, errorMessage) {
                    _this.model.availability.result.visible = false;
                    _this.model.availability.form.visible = true;
                    _this.model.messaging.isBodfsAsServiceLevelEnabled =  false;
                    _this.model.messaging.messageText = errorMessage;
                    _this.model.messaging.messageState = pipUtils.MESSAGING_STATES.ERROR.STYLE;
                    _this.model.cart.visible = true;
                    _this.model.cart.button.disabled = true;
                    _this.model.isErrorState = true;

                    pipEvents.expressDelivery.expressDeliveryError.trigger(pipAnalyticsMessaging.errorStates.fulfillment.expressDelivery[errorCode]);

                    return Mustache.render(_this.view.templates.calculator, _this.model);
                },

                overlayTemplate: function renderOverlayTemplate() {
                    var expressDeliveryContentTemplate = _this.view.templates.expressDeliveryContent;
                    if(pip.features.bodfsOverlayTextFeatureEnabled) {
                         expressDeliveryContentTemplate = _this.view.templates.expressDeliveryContentUpdated
                    }

                    return Mustache.render(expressDeliveryContentTemplate, { calculatorMarkup: _this.view.render.calculatorMarkup(_this.model) });
                },

                calculatorMarkup: function renderCalculatorMarkup() {
                    return Mustache.render(_this.view.templates.calculator, _this.model)
                },

                availabilityTemplate: function renderAvailabilityTemplate(zipCode, bodfsInvJson) {
                    if (bodfsInvJson) {
                        if (RESPONSE_CODES.ERROR[bodfsInvJson.responseCode]) {
                            return _this.view.render.errorTemplate(bodfsInvJson.responseCode, RESPONSE_CODES.ERROR[bodfsInvJson.responseCode]);
                        }
                        if (bodfsInvJson.responseCode == 'true') {
                            _this.model.availability.form.visible = false;
                            _this.model.availability.result.visible = true;
                            _this.model.availability.zipCode = zipCode;
                            _this.model.messaging.isBodfsAsServiceLevelEnabled = pip.features.bodfsAsServiceLevelFeature
                            _this.model.messaging.messageState = pipUtils.MESSAGING_STATES.SUCCESS.STYLE;
                            _this.model.messaging.messageText = getAvailabilityCallSuccessMessage();
                            _this.model.messaging.date = bodfsInvJson.deliveryDate;
                            _this.model.cart.visible = true;
                            _this.model.cart.button.disabled = false;
                            _this.model.isErrorState = false;

                            return Mustache.render(_this.view.templates.calculator, _this.model);
                        }
                        return _this.view.render.errorTemplate('GENERIC_ERROR', RESPONSE_CODES.ERROR.GENERIC_ERROR);
                    }

                    return _this.view.render.errorTemplate('GENERIC_ERROR', RESPONSE_CODES.ERROR.GENERIC_ERROR);
                }
            }
        };

        this.selectors = {
            calculator: '.pip-overlays-wrapper .express-delivery-overlay__calculator',
        };

        this.initListeners();
    };

    ExpressDeliveryOverlay.prototype.initListeners = function initListeners() {
        var _this = this;
        $(document).off('submit.expressDelivery');
        $(document).on('submit.expressDelivery', '#express-delivery-overlay__delivery_form', function (e) {
            e.preventDefault();
            var formValues = $(this).serializeArray();
            var zipCode = formValues[0].value;

            if (!pipValidate.validateZipCode(zipCode)) {
                $(_this.selectors.calculator).html(_this.view.render.errorTemplate('INVALID_ZIPCODE', RESPONSE_CODES.ERROR.INVALID_ZIPCODE));
            } else {
                _this.makeServiceCall(zipCode);
            }
        });

        $(document).off('click.expressDeliveryZipChange');
        $(document).on('click.expressDeliveryZipChange', '.express-delivery-overlay__calculator #express-delivery-overlay__change_delivery_zip', function(e) {
            e.preventDefault();
            _this.model.availability.form.visible = true;
            _this.model.availability.result.visible = false;
            _this.model.messaging.messageText = $('.availability .availability__message-text', '.pip-overlay__express-delivery').text();
            _this.model.messaging.messageState = null;
            _this.model.messaging.date = $('.availability .availability__date', '.pip-overlay__express-delivery').text();
            _this.model.cart.visible = false;
            _this.model.cart.button.disabled = false;

            var calculatorMarkup = _this.view.render.calculatorMarkup(_this.model);
            $(_this.selectors.calculator).html(calculatorMarkup);
        });

        $(document).off('click.expressDeliveryATC');
        $(document).on('click.expressDeliveryATC', '#express-delivery-ATC', function() {
            pipCart.addBodfsItem(pip.products.primary.data.itemId, pip.customer.quantity, pip.customer.expressDeliveryZipCode);
            expressDeliveryOverlayInstance.close();
        });
    };

    var initEventListeners = function initOverlayDisplayListeners() {
        $(document).off('.expressDeliveryLink')
            .on('click.expressDeliveryLink', '.express_delivery_CTA', function (e) {
                e.preventDefault();
                if(pip.features.bodfsDirectAddToCartOverlayAndPIPSourcingEnabled) {
                  pipCart.addBodfsItem(pip.products.primary.data.itemId, pip.customer.quantity, pip.customer.localStore.zipCode);
               }
                else {
                  var expressDelivery = new ExpressDeliveryOverlay();
                  expressDeliveryOverlayInstance = pipOverlay.create(expressDelivery.className, expressDelivery.view.render.overlayTemplate());

                  if (pip.customer.isLocalized) {
                    expressDelivery.makeServiceCall(pip.customer.localStore.zipCode);
                  }

                  // put this in ExpressDeliveryOverlay.selectors
                  // var overlayFAQContent = $('#express_delivery_overlay_content').remove();
                  // $('.bodfs-overlay__faq__content', '.bodfs-overlay__content').html(overlayFAQContent);

                  expressDeliveryOverlayInstance.show();

                  var videoId = $(expressDeliveryOverlayInstance.content).find('#expressDelivery_video').attr('data-videoid');
                  var expressDeliveryVideoPlayer = videoPlayer.create(videoId, {autoplay: false});
                  expressDeliveryVideoPlayer.render('#expressDelivery_video');
               }
            });
    };

    ExpressDeliveryOverlay.prototype.makeServiceCall = function makeServiceCall(zipCode) {
        var _this = this;

        pipUtils.makeDeliveryCapacityCall(pip.products.primary.data.itemId, zipCode, pip.customer.quantity).always(function (bodfsResponse) {
            _this.model.availability.quantity = bodfsResponse.quantityAvail;

            $(_this.selectors.calculator).html(_this.view.render.availabilityTemplate(zipCode, bodfsResponse));
            if (!_this.model.isErrorState) {
                pipQuantity.create('#express-delivery-overlay__quantity');
                pip.customer.expressDeliveryZipCode = zipCode;
            }
            var expressDeliveryClickedAnalytics = {
                eventName: pipAnalyticsMessaging.events.overlays.expressDeliveryOverlayLinkClicked.eventName,
                availability: _this.model.availability && _this.model.availability.quantity && parseInt(_this.model.availability.quantity) > 0 ? "available" : "oos",
                sku: pip.products.primary.data.itemId
            }

            pipEvents.expressDelivery.expressDeliveryOverlayLinkClicked.trigger(expressDeliveryClickedAnalytics);
        });
    };

    function getAvailabilityCallSuccessMessage() {
        return pip.features.bodfsAsServiceLevelFeature ? 'Delivery is available' : 'Earliest Delivery Date:';
    }

	return {
		init: function() {
            initEventListeners();
		},
        shouldDisplayInSubBuyBelt: function() {
            return (!pip.features.bodfsAsServiceLevelFeature
                && pip.fulfillment.shipping
                && pip.fulfillment.shipping.shipToHome
                && pip.fulfillment.shipping.buyOnlineDeliverFromStore
                && !pip.fulfillment.shipping.buyOnlineDeliverFromStore.isAlphaPromptRestricted)
        }
	}
});

}.call(window));